export const environment = {
  production: false,
  enableServiceWorker: true,
  // @ts-ignore
  apiUrl: window["ENV"]["API_URL"],
  appVersion: 'v2.0.35',
  // @ts-ignore
  paystackPublicKey: window["ENV"]["PAYSTACK_KEY"],
  // @ts-ignore
  sageEnabledEntities: window["ENV"]["SAGE_ENABLED_ENTITIES"]
  };
